import React from 'react'
import classNames from 'classnames'

import i18n from 'i18n'

import { IconVisible } from 'svg'

import { STATUS } from './constants'

import styles from './Rewards.module.scss'

export const getStatus = item => {
    if (item.deleted) return STATUS.DELETED
    if (item.initialCount !== -1 && item.givenCount >= item.initialCount) return STATUS.OUT_OF_STOCK
    return STATUS.AVAILABLE
}

export const getColumns = (fields, onSelectColumn) => {
    if (!fields) return []

    const cols = []

    cols.push({
        field: null,
        headerName: '#',
        styles: { width: '10%' },
        getValue: (_, __, columnIndex) => columnIndex + 1,
    })

    cols.push({
        field: 'name',
        headerName: i18n.t('Name'),
        styles: { width: '20%' },
        getValue: v => v,
    })

    cols.push({
        field: 'initialCount',
        headerName: i18n.t('Outcome limit'),
        styles: { width: '15%' },
        getValue: v => {
            if (v === -1) return i18n.t('unlimited')
            return v
        },
    })

    cols.push({
        field: 'givenCount',
        headerName: i18n.t('Awarded'),
        styles: { width: '15%' },
        getValue: v => v,
    })

    cols.push({
        field: null,
        headerName: i18n.t('Left '),
        styles: { width: '15%' },
        getValue: row => {
            if (row.initialCount === -1) return '—'
            return row.initialCount - row.givenCount
        },
    })

    cols.push({
        field: null,
        headerName: i18n.t('Status'),
        styles: { width: '15%' },
        getValue: row => {
            const status = getStatus(row)
            return (
                <div
                    className={classNames(styles.status, {
                        [styles.isOutOfStock]: status === STATUS.OUT_OF_STOCK,
                        [styles.isDeleted]: status === STATUS.DELETED,
                    })}
                >
                    {status === STATUS.AVAILABLE && i18n.t('available')}
                    {status === STATUS.OUT_OF_STOCK && i18n.t('out of stock')}
                    {status === STATUS.DELETED && i18n.t('deleted')}
                </div>
            )
        },
    })

    cols.push({
        field: null,
        headerName: i18n.t('More info'),
        styles: { width: '10%', textAlign: 'end', justifyContent: 'end' },
        getValue: v =>
            v && (
                <div className={styles.eye} onClick={() => onSelectColumn(v)}>
                    <IconVisible />
                </div>
            ),
    })

    return cols
}
